import React from "react";
import SubMenu from "root/Components/Sidebar/SubMenu";

const EstarMenuGroup = ({icon, text, group }) =>
{
    const subMenus = group.items ;

    return (
        <SubMenu key={group.keyName}
            title={text}
            icon={icon}
            items={subMenus}
        />
    )
}

export default  EstarMenuGroup ;